import { Sparkles } from '@/assets/icons'
import { useMatterWhereYouLeftOff } from '@/matter/where-you-left-off/hooks/useMatterWhereYouLeftOff'

export function WhereYouLeftOffActivityItem({ matterId }: { matterId: string }) {
  const { state, error, isLoading } = useMatterWhereYouLeftOff(matterId)

  if (isLoading || error || !state) return null

  return (
    <div className="flex items-start gap-3 border-b border-brand-neutral-200 py-4 text-brand-800">
      <Sparkles aria-hidden className="mt-1 size-4 shrink-0 [&_path]:fill-current" />
      <p className="text-sm leading-5">{state.sentence}</p>
    </div>
  )
}
